import theme from '../../style/theme';

// Banner geometry — theme-driven. Theme tokens (size.banner.{web,mobile}) are
// the single source of truth; aspect ratios are derived from raw width/height
// so the two never drift. See DIS-1181 / DIS-1182.
const {web: webBanner, mobile: mobileBanner} = theme.size.banner;

export const BANNER_ASPECT_RATIO_WEB = webBanner.width / webBanner.height; // 3.25
export const BANNER_ASPECT_RATIO_MOBILE = mobileBanner.width / mobileBanner.height; // 1.52
export const BANNER_DESKTOP_MAX_WIDTH = webBanner.maxWidth; // 1300
export const BANNER_DESKTOP_MAX_HEIGHT = webBanner.maxHeight; // 400

// Legacy aliases. NOTE: the single-value alias resolves to the MOBILE ratio
// because the native carousel has no concept of desktop. Web-desktop call
// sites must use BANNER_ASPECT_RATIO_WEB explicitly when isWebDesktopScreen.
export const CAROUSEL_ASPECT_RATIO = BANNER_ASPECT_RATIO_MOBILE;
export const CAROUSEL_DESKTOP_MAX_HEIGHT = BANNER_DESKTOP_MAX_HEIGHT;

// Carousel UX (not banner geometry — kept literal).
export const CAROUSEL_SLIDE_GAP = 12;
export const CAROUSEL_PEEK_RATIO = 0.9;
export const CAROUSEL_BORDER_RADIUS = 10;
export const CAROUSEL_ARROW_SIZE = 40;

export const CAROUSEL_DOTS = {
  marginTop: 8,
  marginBottom: 4,
  dotSize: 8,
  dotMarginHorizontal: 4,
} as const;
